import PDFJS from './PDFJS';
import URL from './URL';
import MOMENT from './MOMENT';

const MODULE_NAME = 'app.common.wrappers';
const module = angular
    .module(MODULE_NAME, [])
    .service('PDFJS', PDFJS)
    .service('MOMENT', MOMENT)
    .service('URL', URL);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/wrappers/wrappers-module.js